
import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {
    ApplicationActions,
    ApplicationViewModel, PaymentViewModel,
    RequirementFulfillmentViewModel, RequirementsClient,
    StateFeeRequirementViewModel
} from "@/api-client";
import StateFeeSeafarer from "@/features/applications/components/requirements/stateFee/StateFeeSeafarer.vue";
import StateFeeOfficial from "@/features/applications/components/requirements/stateFee/StateFeeOfficial.vue";
import {
  PaymentDetailsProps, StateFeeOfficialProps,
  StateFeeSeafarerProps
} from "@/features/applications/components/requirements/stateFee/StateFeeComponentProps";
import PaymentDetails from "@/features/applications/components/requirements/stateFee/PaymentDetails.vue";
import {ls} from "@/CultureService";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

@Component({
    components: {
        StateFeeSeafarer,
        PaymentDetails,
        StateFeeOfficial,
        ButtonWithConfirm
    }
})
export default class StateFeeRequirement extends Vue {
    public static requirementDescriptionTitle = ls.Applications_Requirements_StateFee_Title_StateFeeRequirement;
    public static headingDescription = ls.Applications_Requirements_StateFee_Heading_PayingStateFee;

    @Prop({required: true})
    application!: ApplicationViewModel; // TODO: Constrain this.
    @Prop({required: true})
    requirementFulfillment!: RequirementFulfillmentViewModel;
    @Prop({required: true})
    requirement!: StateFeeRequirementViewModel;
    @Prop({required: true})
    requirementValue!: PaymentViewModel | null;
    @Prop({required: true})
    actions!: ApplicationActions;

    props!: StateFeeSeafarerProps | PaymentDetailsProps | StateFeeOfficialProps;

    componentName: string | null = null;

    get canRemovePaymentMethod(): boolean {
        return this.requirementValue != null && this.requirementValue.isRefunded;
    }
    
    async created() {
        if (this.actions.canSubmit) {
            this.props = new StateFeeSeafarerProps(this.application, this.requirement, this.requirementValue);
            this.componentName = "StateFeeSeafarer";
        } else if (this.actions.canProcessRequirements) {
            this.props = new StateFeeOfficialProps(this.application, this.requirement);
            this.componentName = "StateFeeOfficial";
        } else {
            this.props = new PaymentDetailsProps(this.requirementValue, this.application, this.requirement!, true);
            this.componentName = "PaymentDetails";
        }
    }
    
    async removePayment() {
        await new RequirementsClient().removeChosenValue(this.application.id, this.requirement.id).then(
            () => this.$emit("application-changed"),
            error => this.$emit("error-happened", error));
    }
}
